<template>
  <div class="modal pedidos">
    <div class="empty" @click="$emit('close')"></div>
    <div class="box">
      <div class="top">
        <div class="title">Fazer pedido</div>
        <div class="close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></div>
      </div>
      <div class="content">
        <form @submit="setPed">
          <input type="text" placeholder="Escreva aqui..." v-model="pedido" minlength="5">
          <button>Enviar</button>
        </form>
      </div>
    </div>
    <Transition name="slide-fade">
      <Alerta v-if="textA !== ''" :text="textA" />
    </Transition>
  </div>
</template>

<script setup>



import Alerta from '@/components/usefulness/alert.vue'
import { ref } from 'vue'

const emits = defineEmits(['close'])

const pedido = ref('')
const textA = ref('')

async function setPed(e) {
  e.preventDefault()
  if (pedido.value !== '') {
    textA.value = 'Pedido enviado!'
    setTimeout(() => { textA.value = '' }, 3000)
  } else {
    textA.value = 'Digite seu pedido!'
  }
}

</script>

<style scoped>
.pedidos .top {
  height: 50px;
}
</style>
